module.exports = __webpack_public_path__ + "img/nav-design-diamondscolliers@2x.d104704.jpg";